/* /hairdresser - the hub page for "frizerski salon Niš".

   The structure follows the competitive gap rather than a generic salon
   template: the two salons ranking above us publish either ~650 words with
   the price list as an IMAGE, or 2.000+ words with three FAQ questions, and
   NEITHER describes the team or mentions groups for weddings and proms.

   So the team and the capacity come immediately after the intro, before the
   list of services, and every price on the page is text in the DOM.

   Colouring, balayage, treatments and men's cuts each keep their own page;
   here they get a paragraph and a link, so the hub ranks for the broad
   queries and the sub-pages for the specific ones. */

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Bredcrumb from '../../HomeMain/Bredcrumb';
import MakeupGallery from './MakeupGallery';
import Faq from '../../ui/Faq';
import ServiceCta from '../../ui/ServiceCta';
import SalonMap from '../../ui/SalonMap';
import { Section, Heading, P, BRAND, INK, BODY, serif, sans } from '../../ui/blocks';
import { PHONE_DISPLAY } from '../../../config/emailjs';
import { linkTo } from '../../../i18n/lang.mjs';

const FRIZURE_IMAGES = [
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915182/Hair_Beauty_Salon_promotion_instagram_story_iljikt.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915180/Hair_Beauty_Salon_promotion_instagram_story_9_mryhkz.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915179/Hair_Beauty_Salon_promotion_instagram_story_8_hsfnjp.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915179/Hair_Beauty_Salon_promotion_instagram_story_7_bbcknv.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915178/5_jsn5jo.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915176/Hair_Beauty_Salon_promotion_instagram_story_6_egnlb0.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915175/Hair_Beauty_Salon_promotion_instagram_story_4_jbqo0b.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915174/Hair_Beauty_Salon_promotion_instagram_story_3_a2rzjf.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915172/Hair_Beauty_Salon_promotion_instagram_story_2_zmdeyr.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915170/7_rfbnnv.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915170/6_fslfgg.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915169/Hair_Beauty_Salon_promotion_instagram_story_1_fdymfi.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915166/4_zekoma.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915165/3_jingzw.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915136/Hair_Beauty_Salon_promotion_instagram_story_egaxzi.jpg",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915146/Hair_Beauty_Salon_promotion_instagram_story_5_za1oxl.png",
]

const FARBANJA_IMAGES = [
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915151/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_5_efiejc.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915146/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_4_uehp3z.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915146/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_yffowv.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915146/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_9_r91s0c.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915142/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_8_pjv8l6.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915142/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_7_svyziw.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915142/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_3_t5lrez.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915141/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_2_fe17mf.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915139/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_6_abwcad.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915139/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_1_gxt8nw.png",
]

/* Sub-heading inside a Section. <Heading> is always the h2, so everything
   below it in the outline needs its own, quieter, h3. */
const H3 = ({ children, first }) => (
  <h3
    style={{
      fontFamily: serif,
      fontSize: '21px',
      fontWeight: 600,
      color: INK,
      lineHeight: 1.3,
      margin: first ? '0 0 12px' : '32px 0 12px',
    }}
  >
    {children}
  </h3>
);

const moreLinkStyle = {
  display: 'inline-block',
  marginTop: '4px',
  fontFamily: sans,
  fontSize: '15px',
  fontWeight: 600,
  color: BRAND,
};

const MoreLink = ({ to, children }) => (
  <Link to={to} style={moreLinkStyle}>{children} →</Link>
);

const Main = () => {
  const { t, i18n } = useTranslation();
  const lang = ['sr', 'en', 'de'].includes(i18n.language) ? i18n.language : 'sr';

  const sameSlot = t('hairdresserService.groups.sameSlotItems', { returnObjects: true });
  const faqItems = t('hairdresserService.faq.items', { returnObjects: true });

  /* Two of the answers name another page. The link lives under the answer
     instead of inside it so the JSON-LD answer text stays plain prose. */
  const faqExtra = (item, i) => {
    if (i === 0) {
      return (
        <MoreLink to="/pricing">{t('hairdresserService.faq.pricingLink')}</MoreLink>
      );
    }
    if (i === 9) {
      return (
        <MoreLink to={linkTo('/musko-sisanje', lang)}>
          {t('hairdresserService.faq.mensLink')}
        </MoreLink>
      );
    }
    return null;
  };

  return (
    <>
      <Bredcrumb
        title={t('hairdresserService.breadcrumbTitle')}
        subtitle={t('hairdresserService.breadcrumbSubtitle')}
      />

      <Section>
        <P style={{ fontSize: '18px', color: INK, fontWeight: 500 }}>
          {t('hairdresserService.intro.p1')}
        </P>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.intro.p2')}</P>
      </Section>

      {/* Team and capacity come before the services on purpose: it is the one
          thing neither competitor says anything about. */}
      <Section tinted>
        <Heading>{t('hairdresserService.team.heading')}</Heading>
        <P>{t('hairdresserService.team.p1')}</P>
        <P>{t('hairdresserService.team.p2')}</P>

        <H3>{t('hairdresserService.team.whyTitle')}</H3>
        <P>{t('hairdresserService.team.whyP1')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.team.whyP2')}</P>

        <H3>{t('hairdresserService.team.waitTitle')}</H3>
        <P>{t('hairdresserService.team.waitP1')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.team.waitP2')}</P>
      </Section>

      <Section>
        <Heading>{t('hairdresserService.groups.heading')}</Heading>
        <P>{t('hairdresserService.groups.p1')}</P>
        <P>{t('hairdresserService.groups.p2')}</P>

        <H3>{t('hairdresserService.groups.practiceTitle')}</H3>
        <P>{t('hairdresserService.groups.practiceP1')}</P>
        <P>{t('hairdresserService.groups.practiceP2')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.groups.practiceP3')}</P>

        <H3>{t('hairdresserService.groups.sameSlotTitle')}</H3>
        {/* listStyle is set on the <li>: a global `ul { list-style: none }`
            in the theme stylesheet otherwise swallows the markers. */}
        <ul style={{ margin: '0 0 18px', paddingLeft: '22px' }}>
          {sameSlot.map((item, i) => (
            <li
              key={i}
              style={{
                fontFamily: sans,
                fontSize: '16px',
                lineHeight: 1.85,
                color: BODY,
                listStyle: 'disc outside',
              }}
            >
              {item}
            </li>
          ))}
        </ul>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.groups.sameSlotEnd')}</P>

        <H3>{t('hairdresserService.groups.bookingTitle')}</H3>
        <P>{t('hairdresserService.groups.bookingP1')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.groups.bookingP2')}</P>

        <H3>{t('hairdresserService.groups.salonOnlyTitle')}</H3>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.groups.salonOnlyP')}</P>
      </Section>

      {/* The salon's own work, kept from the previous version of this page. */}
      <section style={{ padding: '24px 0 48px', background: '#fff' }}>
        <div className="container">
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '8px 32px',
              justifyContent: 'center',
              alignItems: 'flex-start',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <h2 style={{ marginBottom: '8px' }}>{t('hairdresserService.hairstylesTitle')}</h2>
              <MakeupGallery images={FRIZURE_IMAGES} ariaLabel="hairstyle" altPrefix="Hairstyle" />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <h2 style={{ marginBottom: '8px' }}>{t('hairdresserService.coloringTitle')}</h2>
              <MakeupGallery images={FARBANJA_IMAGES} ariaLabel="hair colouring" altPrefix="Hair Colouring" />
            </div>
          </div>
        </div>
      </section>

      <Section tinted>
        <Heading>{t('hairdresserService.services.heading')}</Heading>

        <H3 first>{t('hairdresserService.services.cutTitle')}</H3>
        <P>{t('hairdresserService.services.cutP1')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.services.cutP2')}</P>

        <H3>{t('hairdresserService.services.colourTitle')}</H3>
        <P style={{ marginBottom: '6px' }}>{t('hairdresserService.services.colourP')}</P>
        <MoreLink to={linkTo('/farbanje-kose', lang)}>
          {t('hairdresserService.services.colourLink')}
        </MoreLink>

        <H3>{t('hairdresserService.services.balayageTitle')}</H3>
        <P style={{ marginBottom: '6px' }}>{t('hairdresserService.services.balayageP')}</P>
        <MoreLink to={linkTo('/balayage', lang)}>
          {t('hairdresserService.services.balayageLink')}
        </MoreLink>

        <H3>{t('hairdresserService.services.treatmentsTitle')}</H3>
        <P style={{ marginBottom: '6px' }}>{t('hairdresserService.services.treatmentsP')}</P>
        <MoreLink to={linkTo('/tretmani-kose', lang)}>
          {t('hairdresserService.services.treatmentsLink')}
        </MoreLink>

        <H3>{t('hairdresserService.services.updoTitle')}</H3>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.services.updoP')}</P>

        <H3>{t('hairdresserService.services.mensTitle')}</H3>
        <P style={{ marginBottom: '6px' }}>{t('hairdresserService.services.mensP')}</P>
        <MoreLink to={linkTo('/musko-sisanje', lang)}>
          {t('hairdresserService.services.mensLink')}
        </MoreLink>

        <H3>{t('hairdresserService.services.extensionsTitle')}</H3>
        <P style={{ marginBottom: '6px' }}>{t('hairdresserService.services.extensionsP')}</P>
        <MoreLink to={linkTo('/ekstenzije-za-kosu', lang)}>
          {t('hairdresserService.services.extensionsLink')}
        </MoreLink>
      </Section>

      <Section>
        <Heading>{t('hairdresserService.appointment.heading')}</Heading>

        <H3 first>{t('hairdresserService.appointment.talkTitle')}</H3>
        <P>{t('hairdresserService.appointment.talkP1')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.appointment.talkP2')}</P>

        <H3>{t('hairdresserService.appointment.analysisTitle')}</H3>
        <P>{t('hairdresserService.appointment.analysisP1')}</P>
        <P>{t('hairdresserService.appointment.analysisP2')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.appointment.analysisP3')}</P>

        <H3>{t('hairdresserService.appointment.careTitle')}</H3>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.appointment.careP')}</P>
      </Section>

      <Section tinted>
        <Heading>{t('hairdresserService.prepare.heading')}</Heading>

        <H3 first>{t('hairdresserService.prepare.washTitle')}</H3>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.prepare.washP')}</P>

        <H3>{t('hairdresserService.prepare.photoTitle')}</H3>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.prepare.photoP')}</P>

        <H3>{t('hairdresserService.prepare.timeTitle')}</H3>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.prepare.timeP')}</P>

        <H3>{t('hairdresserService.prepare.groupTitle')}</H3>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.prepare.groupP')}</P>
      </Section>

      <Section>
        <Heading>{t('hairdresserService.why.heading')}</Heading>

        <H3 first>{t('hairdresserService.why.ratingTitle')}</H3>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.why.ratingP')}</P>

        <H3>{t('hairdresserService.why.oneStopTitle')}</H3>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.why.oneStopP')}</P>

        <H3>{t('hairdresserService.why.capacityTitle')}</H3>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.why.capacityP')}</P>

        <H3>{t('hairdresserService.why.parkingTitle')}</H3>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.why.parkingP')}</P>

        <H3>{t('hairdresserService.why.sundayTitle')}</H3>
        <P style={{ marginBottom: 0 }}>{t('hairdresserService.why.sundayP')}</P>
      </Section>

      <Section tinted>
        <Heading>{t('hairdresserService.location.heading')}</Heading>
        <P style={{ marginBottom: '6px' }}>
          <strong style={{ color: INK }}>{t('hairdresserService.location.address')}</strong>
        </P>
        <P style={{ marginBottom: '6px' }}>{t('hairdresserService.location.phone')}</P>
        <P style={{ marginBottom: '6px' }}>{t('hairdresserService.location.hours')}</P>
        <P>{t('hairdresserService.location.parking')}</P>

        {/* Same embed as /contact, from one shared component. */}
        <div style={{ borderRadius: '16px', overflow: 'hidden', lineHeight: 0 }}>
          <SalonMap
            title={t('hairdresserService.location.mapTitle')}
            height={380}
            style={{ width: '100%', display: 'block' }}
          />
        </div>
      </Section>

      <Section>
        <Heading align="center">{t('hairdresserService.faq.heading')}</Heading>
        <Faq items={faqItems} renderExtra={faqExtra} />
      </Section>

      <ServiceCta
        heading={t('hairdresserService.cta.heading')}
        phone={PHONE_DISPLAY}
        address={t('hairdresserService.cta.address')}
        hours={t('hairdresserService.cta.groups')}
      />
    </>
  );
};

export default Main;
